.error{font-size:12px}
/*# sourceMappingURL=component-2WNGHA3Q.css.map */
